import React, { useState, useEffect } from 'react';
import axios from 'axios';

const ManageUsers = () => {
  const [users, setUsers] = useState([]); // Lista de usuários
  const [selectedUser, setSelectedUser] = useState(''); // Usuário selecionado no dropdown
  const [newTag, setNewTag] = useState(''); // Tag a ser adicionada ou removida
  const [feedback, setFeedback] = useState(''); // Mensagem de feedback

  // Campos para adicionar um novo usuário
  const [newUsername, setNewUsername] = useState('');
  const [newPassword, setNewPassword] = useState('');

  // Buscar a lista de usuários quando o componente é montado
  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      fetchUsers(token);
    }

    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = 'http://131.255.179.139:8080/supportApp/FormStyleBP.css';
    document.head.appendChild(link);

    return () => {
      document.head.removeChild(link);
    };
  }, []);

  // Função para buscar os usuários
  const fetchUsers = async (token) => {
    try {
      const response = await axios.get('http://131.255.179.139:5353/manage-users', {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setUsers(response.data);
    } catch (error) {
      console.error('Erro ao buscar usuários:', error);
    }
  };

  // Função para adicionar uma tag a um usuário
  const addTagToUser = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'http://131.255.179.139:5353/manage-users/tags',
        { userId: selectedUser, tags: [newTag], action: 'add' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFeedback(`Tag "${newTag}" adicionada ao usuário.`);
      setNewTag(''); // Limpar o campo de tag
      fetchUsers(token); // Atualizar a lista de usuários
    } catch (error) {
      console.error('Erro ao adicionar tag:', error);
      setFeedback('Erro ao adicionar tag.');
    }
  };

  // Função para remover uma tag de um usuário
  const removeTagFromUser = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'http://131.255.179.139:5353/manage-users/tags',
        { userId: selectedUser, tags: [newTag], action: 'remove' },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFeedback(`Tag "${newTag}" removida do usuário.`);
      setNewTag(''); // Limpar o campo de tag
      fetchUsers(token); // Atualizar a lista de usuários
    } catch (error) {
      console.error('Erro ao remover tag:', error);
      setFeedback('Erro ao remover tag.');
    }
  };

  // Função para adicionar um novo usuário
  const addUser = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'http://131.255.179.139:5353/manage-users/add',
        { username: newUsername, password: newPassword },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFeedback(`Usuário "${newUsername}" adicionado com sucesso.`);
      setNewUsername(''); // Limpar o campo de nome de usuário
      setNewPassword(''); // Limpar o campo de senha
      fetchUsers(token); // Atualizar a lista de usuários
    } catch (error) {
      console.error('Erro ao adicionar usuário:', error);
      setFeedback('Erro ao adicionar usuário.');
    }
  };

  // Função para remover um usuário
  const removeUser = async () => {
    try {
      const token = localStorage.getItem('token');
      await axios.post(
        'http://131.255.179.139:5353/manage-users/remove',
        { userId: selectedUser },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setFeedback(`Usuário removido com sucesso.`);
      fetchUsers(token); // Atualizar a lista de usuários
    } catch (error) {
      console.error('Erro ao remover usuário:', error);
      setFeedback('Erro ao remover usuário.');
    }
  };

    // Função para expirar todos os tokens
    const expireAllTokens = async () => {
      try {
        const token = localStorage.getItem('token');
        await axios.post(
          'http://131.255.179.139:5353/expire-tokens',
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        setFeedback('Todos os tokens foram expirados com sucesso.');
      } catch (error) {
        console.error('Erro ao expirar tokens:', error);
        setFeedback('Erro ao expirar tokens.');
      }
    };

  return (
    <div style={{ color: 'white' }}>

      <h2>Gerenciamento de Usuários</h2>

      <ul>
        {Array.isArray(users) ? (
          users.map((user) => (
            <li key={user.id}>
              {user.username} - Tags: {user.tags ? user.tags.join(', ') : 'Sem tags'}
            </li>
          ))
        ) : (
          <p>Nenhum usuário encontrado.</p>
        )}
      </ul>

      <hr />

      <h3>Gerir Usuário</h3>

      <label>
        Selecione o usuário:
        <select value={selectedUser} onChange={(e) => setSelectedUser(e.target.value)}>
          {users.map((user) => (
            <option key={user.id} value={user.id}>
              {user.username}
            </option>
          ))}
        </select>
      </label>

      <div>
        <label>
          Tag:
          <input
            type="text"
            placeholder="Digite a tag"
            value={newTag}
            onChange={(e) => setNewTag(e.target.value)}
          />
        </label>
      </div>

      <div>
        <button onClick={addTagToUser}>Adicionar Tag</button>
        <button onClick={removeTagFromUser}>Remover Tag</button>
        <button 
      onClick={removeUser} 
      style={{ backgroundColor: 'red', color: 'white' }}
    >
      Remover Usuário
    </button>

      </div>

      <hr />

      <h3>Adicionar Novo Usuário</h3>
      <div>
        <label>
          Nome de Usuário:
          <input
            type="text"
            placeholder="Digite o nome do usuário"
            value={newUsername}
            onChange={(e) => setNewUsername(e.target.value)}
          />
        </label>
      </div>
      <div>
        <label>
          Senha:
          <input
            type="password"
            placeholder="Digite a senha"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
          />
        </label>
      </div>
      <button onClick={addUser}>Adicionar Usuário</button>


      <hr />

      <h3>Expirar Tokens de Todos os Usuários</h3>
      <button onClick={expireAllTokens}>Expirar Todos os Tokens</button>

      <hr />
      {feedback && <p>{feedback}</p>}
    </div>
  );
};

export default ManageUsers;